import * as React from "react";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import "./styles.css";

export default function MediaCard(props) {
  const { to, title, children, photoUrl, style, actions } = props;
  return (
    <Link to={to} className="card">
      <Card
        sx={{
          height: photoUrl ? 220 : 120,
          borderRadius: 2,
          marginBottom: "2rem",
          display: "flex",
          flexDirection: "column",
        }}
        sm={{
          maxWidth: 345,
        }}
      >
        {photoUrl && (
          <CardMedia component="img" height="120" image={photoUrl} />
        )}
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: 120,
            ...style,
          }}
        >
          <Typography gutterBottom variant="h7" component="div" noWrap>
            {title}
          </Typography>
          {children}
        </CardContent>
        {!!actions && <CardActions>{actions}</CardActions>}
      </Card>
    </Link>
  );
}
